<template>
  <v-container class="no-margins">
    <div class="title-icon">
      <h2>{{ $t('ebook.select-element') }}</h2>
      <v-icon small class="mt-n7 mr-n4" @click.prevent="$emit('cancelAdd')">$sl-close</v-icon>
    </div>   

    <div class="title-icon top">
      <h5>{{ $t('ebook.add-element-title3') }}</h5>
      <v-btn icon :href="links.ebook.apprenticeInfo" target="_blank">
        <v-icon>$sl-question</v-icon>
      </v-btn>
    </div>

    <v-form>
      <v-text-field
        v-model="search"
        class="search-field mb-7"
        prepend-icon="$sl-search"
        single-line
        hide-details
        :label="$t('application.search-label')"
      />
    </v-form>

    <template>
      <v-expand-transition v-if="searchedItems.length > 0">
        <v-card>
          <v-list>
            <v-list-item-group>
              <template v-for="(item,index) in searchedItems">
                <v-divider :key="`divider-${index}`" v-if="index"></v-divider>
                <v-list-item :key="`emp-${index}`" @click="elementClick(item)">
                  <v-list-item-content>
                    <v-list-item-title>{{item.name}}</v-list-item-title>

                    <v-list-item-subtitle v-if="!isGradeMaxLevel(item)">
                      {{ 
                        $t('ebookReportElementsModal.sub-elements-approved-counter-text', { 
                          countApprovedSubElements: countApprovedSubElements(item), 
                          countRequiredSubElements: countRequiredSubElements(item) 
                        }) 
                      }}  
                    </v-list-item-subtitle>
                    
                    <v-list-item-subtitle v-else>
                      {{ $t('ebookReportElementsModal.max-level-reached-text') }}
                    </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action v-if="!item.isApproved">
                    <v-icon>$sl-arrow-right</v-icon>
                  </v-list-item-action>

                  <v-icon v-else>$sl-completed</v-icon>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-expand-transition>
    </template>
      
    <template>
      <v-row class="mt-3">
        <v-col>
          <p class="mb-0 text-caption">{{ $t('ebookReportElementsModal.explanation-title') }}</p>
        </v-col>
      </v-row>

      <v-row class="d-flex flex-wrap align-center">
        <v-icon left right>$sl-completed</v-icon>
        <p class="mb-0 text-body-2 text-caption">{{ $t('ebookReportElementsModal.icon-explanation-text') }}</p>
      </v-row>

      <v-row>
        <v-col>
          <p class="mb-0 font-italic text-body-2">{{ $t('ebookReportElementsModal.report-limitation-text') }}</p>
        </v-col>
      </v-row>
    </template>

    <!-- <ActionButton
      type="application"
      actionIcon="$sl-add"      
      @click="modalClick"
    >{{$t('ebook.add-elementpart')}}</ActionButton>-->
    <v-btn block class="mb-6 mt-10 btn-label application" @click.prevent="$emit('cancelAdd')">
      <v-icon>$sl-cancel</v-icon>
      {{$t('labels.cancel')}}
    </v-btn>
  </v-container>
</template>

<script>
import orderBy from 'lodash/orderBy'

// @group Common
// Styled EbookElementModalAdd component
export default {
  name: 'EbookElementModalAdd',

  props: {
    //has elements
    elem: {
      // `'Array'`
      type: Array
    },
  },

  data: () => ({
    links: require('../../../lib/external-links.json'),
    search: '',
    elements: [
      {
        id: 0,
        name: '',
        bookSubElements: [
          {
            id: 0,
            name: ''
          }
        ]
      }
    ]
  }),

  components: {},

  created() {
    this.init()
  },

  watch: {
    elem(val) {
      this.elements = val
    }
  },

  computed: {
    searchedItems() {
      var result = []
      var filteredList = []
      if (this.search === '') {
        result = this.elements
      } else {
        let normalizedSearch = this.search.toLowerCase()
        result = this.elements.filter(x => x.name.toLowerCase().includes(normalizedSearch))
      }
      return orderBy(result, ['isApproved', 'DESC'])
    }
  },

  methods: {
    init() {
      this.elements = this.elem
    },

    //{show: 'elementJudgement', subElement: item, elementName: selectedElement.name}
    elementpart1(sub, elementName) {
      // Fire addElementClick
     // @arg The argument is a object representing subelemenets and element name
      this.$emit('addElementClick', {show: 'elementJudgement', subElement: sub, elementName: elementName})
    },

    elementClick(selectedElement) {
       // Fire addSubElementClick
     // @arg The argument is a object representing selected Element
     this.$emit('addSubElementClick', {show: 'addSubElement', selectedElement: selectedElement})
    },

    countApprovedSubElements(element = {}) {
      return element.numSubElementsFinished
    },

    countRequiredSubElements(element = {}) {
      return element.numSubElementsRequired
    },

    isGradeMaxLevel(element = {}) {
      return !!element.bookSubElements.every(o => o.maxInstructorSkillEstimatedLevel === 4)
    },
  }
}
</script>

<style lang="scss">

</style>
